var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_10716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6.5V10.25L11.25 11.75",
    stroke: "#0092D6",
    strokeWidth: 1.23636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 10.25,
    rx: 6.75,
    ry: 6.75,
    stroke: "#0092D6",
    strokeWidth: 1.23636
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6026 2C14.1952 2.69646 15.5474 3.84059 16.5 5.27331M5.39743 2C3.80477 2.69646 2.4526 3.84059 1.5 5.27331",
    stroke: "#0092D6",
    strokeWidth: 1.23636,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17L14.0678 14.75M2.25 17L3.93204 14.75",
    stroke: "#0092D6",
    strokeWidth: 1.23636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_10716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f9ec35d13c1516300f4ac4afb8e1a43d.svg";
export { ForwardRef as ReactComponent };